import React, { ErrorInfo, ReactNode } from 'react';

import cls from './error-boundary.module.scss';

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // You can also log the error to an error reporting service
    console.error('❌ Error caught by ErrorBoundary:', error);
    console.error('🧩 Error info:', errorInfo);
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;

    if (hasError) {
      return (
        <div className={cls.error}>
          <p className={cls.text}>Error. Try to reload page.</p>
          <button className={cls.reloadBtn} onClick={() => window.location.reload()}>
            Reload
          </button>
        </div>
      );
    }

    return children;
  }
}

export default ErrorBoundary;
